/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { View } from '@az/starc-ui';
import TopSection from './TopSection';
import { type HandleFilterType } from '@/types/filterTypes';
import BottomSection from './BottomSection';

type Props = {
  viewingPartTypes: boolean;
  setViewingPartTypes: (viewingPartTypes: boolean) => void;
  setAnalyticsCalled: (analyticsCalled: boolean) => void;
  handleFilter?: (filter: HandleFilterType) => void;
};

const PartTypesView = ({
  viewingPartTypes,
  setViewingPartTypes,
  setAnalyticsCalled,
  handleFilter,
}: Props) => {
  return (
    <View direction="column" padding={{ s: [0, 4], l: [0, 5] }}>
      <TopSection
        setViewingPartTypes={setViewingPartTypes}
        setAnalyticsCalled={setAnalyticsCalled}
      />
      <BottomSection viewingPartTypes={viewingPartTypes} handleFilter={handleFilter} />
    </View>
  );
};

export default PartTypesView;
